
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic12 as ObiHydraulic12Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-12.js';
 
 
 

 
 export const ObiHydraulic12 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-12',
   elementClass: ObiHydraulic12Element,
   events: {
     
   }
  });
 
 